import React, { PureComponent } from 'react';
import b from 'b_';

import './events-page.css';

import EventItemStub from '@components/event-item/event-item.stub';

const class_ = b.with('events-page-stub');

export default class EventsPageStub extends PureComponent {
    public render() {
        return (
            <div className={class_()}>
                <EventItemStub type="horizontal" />
                <EventItemStub type="horizontal" />
                <EventItemStub type="horizontal" />
            </div>
        );
    }
}
